<span class="text-color-gray-13" *ngIf="date | dateDiffFromNow as localizedDate" (click)="dateClicked.emit()">{{ localizedDate }}</span>
